import {kInstagramLink} from "../../constants/links";

export default function SystemDrawerInstagramImage() {
    // Used in SystemAppDrawer to display ummia channel
    // Instagram link as a logo

    // BUILD
    return (
        <a href={kInstagramLink}
           target="_blank"
           rel="noreferrer">
            <img className="h-[32px] w-auto object-contain transition-all duration-150 hover:drop-shadow-[0_0_8px_rgba(220,140,235,0.4)] cursor-pointer"
                 src="/images/SystemInstagramIcon.png"
                 alt="YouTube" />
        </a>
    );
}